import { render, staticRenderFns } from "./UAWhitelist.vue?vue&type=template&id=2fa3ceb4&"
import script from "./UAWhitelist.vue?vue&type=script&lang=js&"
export * from "./UAWhitelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports